'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$99() {
  this.bqj = null;
  this.bqk = false;
}
export { $c_Lpresto_PrestoRouter$$anon$99 as $c_Lpresto_PrestoRouter$$anon$99 };
$p = $c_Lpresto_PrestoRouter$$anon$99.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$99;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$99() {
}
export { $h_Lpresto_PrestoRouter$$anon$99 as $h_Lpresto_PrestoRouter$$anon$99 };
$h_Lpresto_PrestoRouter$$anon$99.prototype = $p;
$p.bW = (function() {
  if ((!this.bqk)) {
    this.bqj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bqk = true;
  }
  return this.bqj;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$99 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$99, "presto.PrestoRouter$$anon$99", ({
  P8: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$99 as $d_Lpresto_PrestoRouter$$anon$99 };
//# sourceMappingURL=presto.-Presto-Router$$anon$99.js.map
